export type ContactStatus = 'idle' | 'submitting' | 'success' | 'error';

export type ProjectType = 'web' | 'custom' | 'maintenance' | 'hosting' | 'other';

export type Budget = '690-1290' | '1290-2490' | '2490-5000' | 'more-than-5000' | 'not-defined';

export interface ContactRequest {
  name: string;
  email: string;
  phone: string;
  company: string;
  projectType: ProjectType;
  budget: Budget;
  message: string;
  privacyAccepted: true;
  turnstileToken: string;
  website: string;
  startedAt: number;
}

export interface ContactResponse {
  success: true;
}

export type ApiErrorCode =
  | 'VALIDATION_ERROR'
  | 'INVALID_REQUEST'
  | 'VERIFICATION_FAILED'
  | 'TOO_MANY_REQUESTS'
  | 'ORIGIN_NOT_ALLOWED'
  | 'PAYLOAD_TOO_LARGE'
  | 'UNSUPPORTED_MEDIA_TYPE'
  | 'DELIVERY_FAILED'
  | 'INTERNAL_ERROR'
  | 'METHOD_NOT_ALLOWED'
  | 'NOT_FOUND';

export interface ApiError {
  success: false;
  error: {
    code: ApiErrorCode;
    message: string;
  };
}

export type ContactErrorKind = 'validation' | 'verification' | 'rate-limit' | 'network' | 'server';

export class ContactApiError extends Error {
  constructor(readonly kind: ContactErrorKind) {
    super(kind);
    this.name = 'ContactApiError';
  }
}
